import { Box } from "@material-ui/core";
import React from "react";
import TabsWrapper from "./styled";
const { Component, cloneElement } = React;

// Tab
const Tab = (props) => {
  const { className, label, isActive, onClick } = props;

  const cssTabClass = `tabs__tab${className !== undefined ? className : ''}`;

  const activeLinkClass = `tabs__tab-link ${
    isActive ? "tabs__tab-link--active" : ""
  }`;

  return (
    <li className={cssTabClass}>
      <a href className={activeLinkClass} onClick={onClick}>
        {label}
      </a>
    </li>
  );
};

// Tabs
class Tabs extends Component {
  constructor(props) {
    super(props);

    this.state = { activeIndex: props.defaultActiveIndex || 0 };
  }

  handleTabClick = (tabIndex) => {
    if (tabIndex !== this.state.activeIndex) {
      this.setState({ activeIndex: tabIndex });
    }

    if (this.props.onClick) {
      this.props.onClick(tabIndex);
    }
  };

  cloneTabElement = (tab, index = 0) => {
    const { activeIndex } = this.state;

    return cloneElement(tab, {
      onClick: () => this.handleTabClick(index),
      tabIndex: index,
      isActive: index === activeIndex,
    });
  };

  renderChildrenTabs = () => {
    const { children } = this.props;
    if (!Array.isArray(children)) {
      return this.cloneTabElement(children);
    }

    return children.map(this.cloneTabElement);
  };

  renderActiveTabContent() {
    const { children } = this.props;
    const { activeIndex } = this.state;

    if (children[activeIndex]) {
      return children[activeIndex].props.children;
    }

    return children.props.children;
  }

  render() {
    const { className } = this.props;

    const cssClass = `tabs${className !== undefined ? className : ''}`;

    return (
      <TabsWrapper>
        <Box padding={1}>
          <section className={cssClass}>
            <ul className={"tabs__list"}>{this.renderChildrenTabs()}</ul>
            <div className={"tabs__content"}>
              {this.renderActiveTabContent()}
            </div>
          </section>
        </Box>
      </TabsWrapper>
    );
  }
}

Tabs.Tab = Tab;

export { Tabs };
